import { createContext } from 'react'

const HandleViewContent = createContext()
export default HandleViewContent
